/** 数据类型 */
export const DATA_TYPE = {
    /** 单项选择 */
    SINGLE: 'single',
    /** 多项选择 */
    MULTI: 'multi',
    /** 级联选择 */
    TREE: 'tree',
    /** 地区选择 */
    REGION: 'region',
    /** 日期选择 */
    DATE: 'date',
    /** 日期范围选择 */
    DATE_RANGE: 'dateRange',
    /** 时间选择 */
    TIME: 'time'
};
/** 行高 */
export const ROW_HEIGHT = 44;
